define("calendar/components/calendar/settings/bttp/report", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Ui::CheckboxSwitch
    @labelText={{t "bttp.toggle_title"}}
    @propertyToggled={{@bttpToggledOn}}
    @toggleAction={{@toggleBttp}}
    class="has--multiLine u--p__0 u--m__b at--bttpRetention__bttpToggleButton"
  />
  <p class="u--text--light" data-test-id="bttp-toggle">
    {{#if (or @isInstagram @isFacebook @rolloutBttpV3)}}
      {{html-safe (t "bttp.toggle_details_2")}}
    {{else}}
      {{html-safe (t "bttp.toggle_details")}}
      <Shared::Link @href={{this.learnMoreLink}} @text={{t "shared_phrases.learn_more"}} />
    {{/if}}
  </p>
  {{#if @bttpToggledOn}}
    {{#if @isLegacyBttp}}
      {{#unless @immediateBttpEnabled}}
        <p class="u--text--bold u--m__t__lg u--m__b__0">
          {{t "bttp.calculated_bttp" nickname=@singleSocialProfile.displayNickname num=@numOfBttpTimeSlots}}
        </p>
        <p class="u--text--light u--text--sm">
          {{@bttpLastCalculatedText}}
        </p>
      {{/unless}}
      <button
        class="o--btn o--btn--outline qa--generate_bttp_btn"
        type="button"
        {{on "click" (perform @triggerBttp true)}}
      >
        {{#if @immediateBttpEnabled}}
          {{t "bttp.enable_immediate_bttp"}}
        {{else}}
          {{t "bttp.recalculate"}}
        {{/if}}
      </button>
    {{else if this.canRecalculateBttp}}
      <button
        class="o--btn o--btn--outline qa--generate_bttp_btn"
        type="button"
        {{on "click" (perform @triggerBttp true)}}
      >
        {{t "bttp.recalculate"}}
      </button>
    {{/if}}
  {{/if}}
  
  <Calendar::Settings::Bttp::InfoCard
    @immediateBttpEnabled={{@immediateBttpEnabled}}
    @isLegacyBttp={{@isLegacyBttp}}
    @isOnLegacyPlan={{@isOnLegacyPlan}}
  />
  */
  {
    "id": "6sRb8Gwu",
    "block": "[[[8,[39,0],[[24,0,\"has--multiLine u--p__0 u--m__b at--bttpRetention__bttpToggleButton\"]],[[\"@labelText\",\"@propertyToggled\",\"@toggleAction\"],[[28,[37,1],[\"bttp.toggle_title\"],null],[30,1],[30,2]]],null],[1,\"\\n\"],[10,2],[14,0,\"u--text--light\"],[14,\"data-test-id\",\"bttp-toggle\"],[12],[1,\"\\n\"],[41,[28,[37,3],[[30,3],[30,4],[30,5]],null],[[[1,\"    \"],[1,[28,[35,4],[[28,[37,1],[\"bttp.toggle_details_2\"],null]],null]],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[28,[35,4],[[28,[37,1],[\"bttp.toggle_details\"],null]],null]],[1,\"\\n    \"],[8,[39,5],null,[[\"@href\",\"@text\"],[[30,0,[\"learnMoreLink\"]],[28,[37,1],[\"shared_phrases.learn_more\"],null]]],null],[1,\"\\n\"]],[]]],[13],[1,\"\\n\"],[41,[30,1],[[[41,[30,6],[[[41,[51,[30,7]],[[[1,\"      \"],[10,2],[14,0,\"u--text--bold u--m__t__lg u--m__b__0\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"bttp.calculated_bttp\"],[[\"nickname\",\"num\"],[[30,8,[\"displayNickname\"]],[30,9]]]]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--text--light u--text--sm\"],[12],[1,\"\\n        \"],[1,[30,10]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[11,\"button\"],[24,0,\"o--btn o--btn--outline qa--generate_bttp_btn\"],[24,4,\"button\"],[4,[38,7],[\"click\",[28,[37,8],[[30,11],true],null]],null],[12],[1,\"\\n\"],[41,[30,7],[[[1,\"        \"],[1,[28,[35,1],[\"bttp.enable_immediate_bttp\"],null]],[1,\"\\n\"]],[]],[[[1,\"        \"],[1,[28,[35,1],[\"bttp.recalculate\"],null]],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"canRecalculateBttp\"]],[[[1,\"    \"],[11,\"button\"],[24,0,\"o--btn o--btn--outline qa--generate_bttp_btn\"],[24,4,\"button\"],[4,[38,7],[\"click\",[28,[37,8],[[30,11],true],null]],null],[12],[1,\"\\n      \"],[1,[28,[35,1],[\"bttp.recalculate\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]],null]],[]]]],[]],null],[1,\"\\n\"],[8,[39,9],null,[[\"@immediateBttpEnabled\",\"@isLegacyBttp\",\"@isOnLegacyPlan\"],[[30,7],[30,6],[30,12]]],null]],[\"@bttpToggledOn\",\"@toggleBttp\",\"@isInstagram\",\"@isFacebook\",\"@rolloutBttpV3\",\"@isLegacyBttp\",\"@immediateBttpEnabled\",\"@singleSocialProfile\",\"@numOfBttpTimeSlots\",\"@bttpLastCalculatedText\",\"@triggerBttp\",\"@isOnLegacyPlan\"],false,[\"shared/ui/checkbox-switch\",\"t\",\"if\",\"or\",\"html-safe\",\"shared/link\",\"unless\",\"on\",\"perform\",\"calendar/settings/bttp/info-card\"]]",
    "moduleName": "calendar/components/calendar/settings/bttp/report.hbs",
    "isStrictMode": false
  });
  let ReportComponent = _exports.default = (_dec = (0, _service.inject)('calendar/bttp'), (_class = class ReportComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "bttp", _descriptor, this);
      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor2, this);
    }
    get learnMoreLink() {
      return this.bttp.learnMoreLink(this.selectedSocialProfiles.firstProfile?.profileType);
    }
    get canRecalculateBttp() {
      if (this.args.isInstagram || this.args.isFacebook) {
        return true;
      }
      return !this.args.isLegacyBttp || this.args.rolloutBttpV3;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "bttp", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ReportComponent);
});